import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aacr-header',
  templateUrl: './aacr-header.component.html',
  styleUrls: ['./aacr-header.component.scss']
})
export class AacrHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
